import React from "react";
import {
    StyledModal,
    StyledH2,
    StyledLabel,
    CheckboxIcon,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import storeVatRate, {
    setConfirmationActivateClick,
    setDataIsUpdatedFranchise,
    setDataIsUpdatedShops,
} from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";

export function ConfirmationActivate() {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { confirmationActivateClick, listLinks } = useSnapshot(storeVatRate);
    const uuidUser = localStorage.getItem("uuidUser");

    function getJustFranchise(list: any) {
        let res: any = [];
        list.forEach((el: string) => {
            if (el.indexOf("vatRateArchiveAssocEdit") === -1) {
                res.push(el);
            }
        });
        return res;
    }
    async function archiveVatRateAssocMulti(listLinks: any) {
        try {
            const vatRatesData = listLinks.map((link: string) => {
                const url = new URL(link);
                const params = new URLSearchParams(url.search);

                return {
                    idVatRate: params.get("idVatRate"),
                    archived: params.get("archived") === "true",
                    shopId: params.get("shopId"),
                };
            });

            const firstUrl = new URL(listLinks[0]);
            const firstParams = new URLSearchParams(firstUrl.search);

            const payload = {
                userId: parseInt(firstParams.get("userId")!),
                franchiseId: firstParams.get("franchiseId"),
                operatorId: firstParams.get("operatorId"),
                uuidUser: uuidUser,
                vatRates: vatRatesData,
            };

            const data: any = await fetchGlobal(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/vatRateArchiveBulk`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (data.error) {
                throw Error("Error while archive selection!");
            }

            setDataIsUpdatedFranchise!(true);
            setDataIsUpdatedShops!(true);

            toast.success(t("The vat rate is successfully restored"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });
        } catch (e) {
            toast.error(t("There's an error"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            console.error("Error in archiveVatRateAssocMulti:", e);
        }
    }
    return (
        <StyledModal toggle={true} isOpen={confirmationActivateClick} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() =>
                    setConfirmationActivateClick(!confirmationActivateClick)
                }
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        "Attention! This VAT(s) is archived at the store level.\n\nDo you want to activate it in shops too?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        let links: any = getJustFranchise(listLinks);

                        archiveVatRateAssocMulti(links);
                        setConfirmationActivateClick(
                            !confirmationActivateClick
                        );
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        archiveVatRateAssocMulti(listLinks);
                        setConfirmationActivateClick(
                            !confirmationActivateClick
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
